@for (type of linearBetslipTypesOrder; track type) {
    @switch (type) {
        @case (betslipTypes.Combo) {
            @if (comboSlip) {
                <bs-digital-linear-result-combo [succeededSlip]="comboSlip" [oddsDisplayFormat]="oddsDisplayFormat" [inColumn]="inColumn" />
            }
        }
        @case (betslipTypes.Single) {
            @if (singleSlips && singleSlips.length) {
                <bs-digital-linear-result-single [succeededSlips]="singleSlips" [oddsDisplayFormat]="oddsDisplayFormat" [inColumn]="inColumn" />
            }
        }
        @case (betslipTypes.System) {
            @if (systemSlips && systemSlips.length) {
                @for (slip of systemSlips; track slip) {
                    <bs-digital-linear-result-system-wrapper [succeededSlip]="slip" [oddsDisplayFormat]="oddsDisplayFormat" [inColumn]="inColumn" />
                }
            }
        }
        @case (betslipTypes.BetBuilder) {
            @if (betBuilderSlips.length) {
                @if (showOneBetBuilderBetPerModule) {
                    @for (slip of betBuilderSlips; track slip) {
                        <bs-digital-linear-result-bet-builder
                            [succeededSlips]="[slip]"
                            [oddsDisplayFormat]="oddsDisplayFormat"
                            [inColumn]="inColumn" />
                    }
                } @else {
                    <bs-digital-linear-result-bet-builder
                        [succeededSlips]="betBuilderSlips"
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [inColumn]="inColumn" />
                }
            }
        }
        @case (betslipTypes.Teaser) {
            @if (teaserSlip) {
                <bs-digital-linear-result-combo
                    [succeededSlip]="teaserSlip"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [inColumn]="inColumn"
                    [isTeaser]="true" />
            }
        }
    }
}

@if (showRewardsCta) {
    <bs-result-rewards-cta />
}
